import { FC, useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Footer } from './components/Footer'
import { HeaderWrapper } from './components/header/HeaderWrapper'
import { ScrollTop } from './components/ScrollTop'
import { PageDataProvider } from './core'
import { SnackbarProvider } from '../context/SnackbarContext'
import {
  DrawerComponent,
  MenuComponent,
  ScrollComponent,
  ScrollTopComponent,
  SwapperComponent,
  ToggleComponent
} from '../assets/ts/components'
import { WithChildren } from '../helpers'
import { AiAssistantProvider } from '../context/AiAssistantContext'
import { NotificationInit } from './components/NotificationInit'

const headingImage = {};
const MasterLayoutContent: FC = () => {
  const location = useLocation()

  useEffect(() => {
    setTimeout(() => {
      ToggleComponent.reinitialization();
      ScrollTopComponent.reinitialization();
      DrawerComponent.reinitialization();
      MenuComponent.reinitialization();
      ScrollComponent.reinitialization();
      SwapperComponent.reinitialization();

      (window as any)?.KTMenu?.createInstances?.();
    }, 500)
  }, [location.key])

  return (
    <div className='page d-flex flex-row flex-column-fluid'>
      <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper'>
        <HeaderWrapper />
        <div className='d-flex flex-column flex-row-fluid' id='kt_Content_wrapper' style={headingImage}>
          <div className='row m-0'>
            <div className={'col-12 px-0'}>
              <Outlet />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  )
}

const MasterLayout: FC<WithChildren> = () => {
  return (
    <PageDataProvider>
        <AiAssistantProvider>
          <NotificationInit />
          <MasterLayoutContent />
          {/* end:: Modals */}
          <ScrollTop />
        </AiAssistantProvider>
    </PageDataProvider>
  )
}

export { MasterLayout }